<div class="app-heading" [class.no-top-margin]="noTopMargin !== null">
	<span class="heading-content">
		<ng-content></ng-content>
		
		<span *ngIf="badge" [matBadge]="badge" [matBadgeColor]="badgeColor" matBadgeOverlap="false" [class.text-badge]="textBadge"></span>
	</span>
</div>